import React, { Component } from 'react';
import CatLoading from './catloading';


class Subcategory extends Component {

    data = this.props.Data;
    language = this.props.Language;

    render() {
        console.log(this.data.logo);
        return (
            <div className={`categories-item ${this.props.Active?'active':''}`} onClick={ () => this.props.handleCategory(this.data.id)} >
                {
                        this.props.Language == "en" ? this.data['name_eng']
                        : this.props.Language == "krd" ? this.data.name_krd
                        : this.data.name_ar
                    }
            </div>
        );
    }
}

export default Subcategory;